// extracted by mini-css-extract-plugin
export default {"Notifications":"Notifications_Notifications__HB4nj","Notifications__new":"Notifications_Notifications__new__numox","Notifications__table":"Notifications_Notifications__table__KoCJR"};